// UserStatusBar.jsx — Floating bottom-left global do user.
//
// Sprint v9.13 — Pedro pediu o user-menu visível em TODAS as tabs.
// Brainstorm decidiu posição flutuante bottom-left (padrão
// Linear/Notion/Figma/Slack).
//
// Layout:
//   • Compact pill (avatar + nome + ícones) — sempre visível
//   • z-30 fixed bottom-left
//   • backdrop-blur + bg surface/90 — legível sobre qualquer conteúdo
//   • RECOLHE junto com o sidebar (Code): quando o sidebar colapsa, a pílula
//     vira só o avatar; reexpande no hover. Sincroniza via o evento
//     `apolo:sidebarCollapsed` (CodeSidebar) + localStorage no boot.
//
// Reusa UserMenu interno — mesma logic (avatar, hooks, plugins, logout).

import { useEffect, useState } from 'react';
import UserMenu from './UserMenu.jsx';

const LS_COLLAPSED = 'apolo:sidebar:collapsed';

function readCollapsed() {
  try {
    return typeof window !== 'undefined' && window.localStorage.getItem(LS_COLLAPSED) === '1';
  } catch {
    return false;
  }
}

export default function UserStatusBar() {
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const onCollapse = (e) => setCollapsed(Boolean(e.detail?.collapsed));
    window.addEventListener('apolo:sidebarCollapsed', onCollapse);
    return () => window.removeEventListener('apolo:sidebarCollapsed', onCollapse);
  }, []);

  // Recolhido = só avatar; o hover reexpande pra dar acesso às ações.
  const effectiveCollapsed = collapsed && !hovered;

  return (
    <aside
      aria-label="Conta do usuário"
      className={`pointer-events-none fixed bottom-3 z-50 hidden transition-all duration-200 lg:flex ${
        // Colapsado (e sem hover): avatar centralizado na largura do rail do
        // CodeSidebar (w-14). Expandido OU hover: ancora à esquerda (left-3) pra
        // o popout crescer pra direita sem cortar.
        effectiveCollapsed ? 'left-0 w-14 justify-center' : 'left-3'
      }`}
    >
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="pointer-events-auto inline-flex items-center gap-2 rounded-full border border-apolo-borderSubtle bg-apolo-surface1/85 px-2 py-1 shadow-[0_8px_24px_-12px_rgba(0,0,0,0.6),0_0_0_1px_rgba(255,255,255,0.04)] backdrop-blur-md transition-all duration-200"
      >
        <UserMenu collapsed={effectiveCollapsed} />
      </div>
    </aside>
  );
}
